// components/Reusablesteps/onboarding/PatientTypeScreen.jsx
// Two hover-card selector: Existing patient | New patient.

import React from "react";
import styles from "./Onboarding.module.css";
import { SecureLine, ArrowRight } from "./onboardingTokens";
import { ExistingPatientIcon, NewPatientIcon } from "../../config/icons";

/* ─── Arrow icon coloured for the card context ── */
const CardArrow = () => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="none"
    stroke="#fff" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

/* ─── Single type card ─────────────────────────────────────────── */
const TypeCard = ({ label, emoji, desc, onClick }) => (
  <button
    className={styles.typeCard}
    onClick={onClick}
    type="button"
  >
    <span className={styles.typeCardEmoji}>
      {/* <img src={emoji} alt={label} className={styles.typeCardEmojiImg} /> */}
      {emoji}
    </span>
    <div>
      <div className={styles.typeCardLabel}>{label}</div>
      <div className={styles.typeCardDesc}>{desc}</div>
    </div>
    <div className={styles.typeCardArrow}>
      <CardArrow />
    </div>
  </button>
);

/* ─── PatientTypeScreen ─────────────────────────────────────────── */
/**
 * @param {function} onSelect  - called with "existing" | "new"
 */
const PatientTypeScreen = ({ onSelect }) => (
  <div className={styles.wrap}>
    <div className={styles.centre}>

      <div style={{ textAlign: "center" }}>
        <h2 className={styles.question}>
          Are you a new or existing patient?
        </h2>
        <p className={styles.desc}>
          This helps us personalise your experience
        </p>
      </div>

      <div className={styles.typeCardsRow}>
        <TypeCard
          label="Existing Patient"
          emoji= {<ExistingPatientIcon />}
          desc="I've visited before"
          onClick={() => onSelect("existing")}
        />
        <TypeCard
          label="New Patient"
          emoji= {<NewPatientIcon />}
          desc="First time here"
          onClick={() => onSelect("new")}
        />
      </div>

    </div>
    {/* <SecureLine /> */}
  </div>
);

export default PatientTypeScreen;
